import React, { Fragment } from 'react'
import { graphql } from 'gatsby'

import { useNavbarTheme } from '../contexts/NavbarTheme'

import theme from '../styles/theme'
import { rem, media } from '../styles/tools'

import SEO from '../components/SEO'
import Shell from '../components/Shell'
import Wrapper from '../components/Wrapper'
import Space from '../components/Space'
import Post from '../components/Post'
import BackgroundText from '../components/BackgroundText'
import HelloFab from '../components/HelloFab'
import NewsletterFooter from '../components/NewsletterFooter'
import { AutoSlide } from '../components/Animated'
import { ContentAboveFooter } from '../components/Footer'
import { Headline } from '../styles/typography'

export const pageQuery = graphql`
  query($tag: String) {
    allMarkdownRemark(
      limit: 1000
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            description
            thumbnail {
              ...textContainerWide
            }
          }
        }
      }
    }
  }
`

export default ({ data, pageContext: { tag } }) => {
  const { edges: posts } = data.allMarkdownRemark

  useNavbarTheme('dark')

  return (
    <Fragment>
      <SEO title={`Articles tagged "${tag}"`} />

      <Shell>
        <ContentAboveFooter>
          <Wrapper padded>
            <Space y={theme.space.xxl} />
            <BackgroundText>OUR BLOG</BackgroundText>
            <AutoSlide
              left
              css={{
                [media.max.tabletMd]: { display: 'none' },
                marginTop: '-6.35vmax',
                marginLeft: rem(-5),
              }}
            >
              <Headline>Articles tagged "{tag}"</Headline>
            </AutoSlide>
            <Space y={{ mobile: 65, laptop: theme.space.xxl }} />
            <ul
              css={{
                display: 'grid',
                gridGap: rem(60),
                overflowX: 'hidden',
                [media.laptop]: {
                  gridGap: rem(theme.space.xxl),
                  overflowX: 'visible',
                },
              }}
            >
              {posts.map(({ node: post }, i) => (
                <Post
                  as="li"
                  direction={(i + 1) % 2 ? 'right' : 'left'}
                  key={post.id}
                  slug={post.fields.slug}
                  title={post.frontmatter.title}
                  description={post.frontmatter.description}
                  thumbnail={post.frontmatter.thumbnail}
                />
              ))}
            </ul>
            <Space y={theme.space.xxl} />
          </Wrapper>
        </ContentAboveFooter>
        <NewsletterFooter />
        <HelloFab />
      </Shell>
    </Fragment>
  )
}
